import { Container } from "react-bootstrap";
import styles from "../../../assets/styles/ProjectPage.module.css"
import PollsPageView from "./PollsPageView";
import { useParams } from "react-router-dom";
import NotFoundPage from "../../NotFound/NotFoundPage";

const PollsPage = () => {
    const {pollTemplateId, pollTagId} = useParams();
    return (
        <Container className={styles.projectPage}>
            <>
                {(pollTemplateId && pollTagId) ?
                <PollsPageView
                    pollTemplateId={pollTemplateId}
                    tagId={pollTagId}
                />:
                <NotFoundPage/>}
                
            </>
        </Container>
    );
};

export default PollsPage;